import { BaseEntity } from "yt-ng-framework";
import { EOtpremnica } from "../eotpremnica/eotpremnica";
import { NullTemplateVisitor } from "@angular/compiler";

export class EPrijemnica
 extends EOtpremnica {

    constructor(){
        super();
    }
    EOtpremnicaID: number = null;
    EpID: string = null;
    BrojUlaznePrijemnice: string = null;
    BrojPrijemnice: string = null;
    DatumPrijemnice: Date = null;
    BrojUlazneOtpremnice: string = null;
    StatusTooltip: string = null;

    Deserialize(input: any){
        super.Deserialize(input);
        this.EOtpremnicaID=input.EOtpremnicaID;
        this.EpID = input.EpID;
        this.BrojUlaznePrijemnice = input.BrojUlaznePrijemnice;
        this.BrojPrijemnice = input.BrojPrijemnice;
        this.DatumPrijemnice = input.DatumPrijemnice;
        this.BrojUlazneOtpremnice = input.BrojUlazneOtpremnice;
        this.StatusTooltip = input.StatusTooltip;

        return this;
    }

    Serialize(input: EPrijemnica){
        return input;
    }
}

